<style scoped lang="less">
    .comm_main {position:relative; background:#fff; box-sizing: border-box; padding:20px;
    // .comm_main {  position:relative; border:20px solid #f6f7fb;  background:#fff; box-sizing: border-box; padding:20px;
      .comm_main_head {position:absolute; top:0;left:0;right:0; padding:20px; border-bottom:1px solid #e5e7ea; font:bold 16px/1 ""; color:#333; }
      .comm_main_body { box-sizing: border-box;  }
      &.ispadding {padding:16px;}
      &.overflowAuto {overflow: auto;}
      &.overflowHidden {overflow: hidden;}
    }

  .fixed_tabs {
  }

</style>
<template>
    <div ref="comm_main" class="comm_main" :style="{'padding-top':headHeight+'px','height':comm_main_Height+'px'}">
      <!-- <div ref="comm_main_head" class="comm_main_head"> -->
      <div ref="comm_main_head" class="comm_main_head" v-if="atitle" >
        <slot name="title">{{title}}</slot>
      </div>
      <!-- <div class="comm_main_body" :class="{ 'ispadding': abody==true || abody=='true'}" > -->
        <slot></slot>
      <!-- </div> -->
    </div>
</template>
<script>
export default {
  name: 'comm_main',
  props: {
    title: {
      type: String,
    },
    type: {
      type: String,
    },
    overflow: {
      type: String,
    },
    body:{
      type: [Boolean, String],
    },
  },
  data: function() {
    return {
      atitle: false,
      atype: this.type,
      abody: this.body,
      headHeight:'20',
      comm_main_Height:'auto',
    }
  },

  created() {},

  mounted() {
    let vm=this;
    
    vm.$nextTick(function() {
      // (!vm.title) ? vm.atitle=true : vm.atitle=false
      vm.title
      // 判断是否显示 title 
      if(vm.title == '' || vm.title == undefined ){
        vm.atitle=false
      }else{
        vm.atitle=true
      }
      vm.$nextTick(function() {
        if(vm.atitle){
          vm.headHeight = $(vm.$refs.comm_main_head).outerHeight()+18;
          // console.log($(vm.$refs.comm_main_head).outerHeight());
        }

      })
      
      // 设置滚动条 在 comm_main 里面
      if(vm.overflow=='auto'){

        $(vm.$refs.comm_main).addClass('overflowAuto');
        // 给comm_main 最小高度
        // if($(vm.$refs.comm_main).offset().top){
          let wh=$(window).height();
          let setTop=$(vm.$refs.comm_main).offset().top;
          vm.comm_main_Height=wh-setTop-20;
      // console.log('window.onresize',oldWindowResize)
      }else if (vm.overflow=='hidden'){

        $(vm.$refs.comm_main).addClass('overflowHidden');

          let wh=$(window).height();
          let setTop=$(vm.$refs.comm_main).offset().top;
          vm.comm_main_Height=wh-setTop-vm.headHeight;
          console.log('----------------',vm.comm_main_Height,wh,setTop,vm.headHeight);
      }


    })
  },

  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/commonplugin/common/comm_main.vue